import { render, staticRenderFns } from "./ItemDetailHistories.vue?vue&type=template&id=f9db77e4&"
import script from "./ItemDetailHistories.vue?vue&type=script&lang=js&"
export * from "./ItemDetailHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports